import { MoveRight, Phone } from "lucide-react";
import { images } from "../../assets/assets";
import Navbar from "../../Components/Navbar";
import { Link } from "react-router-dom";
import Footer from "../../Components/Footer";
import { useEffect } from "react";
import director from "../../assets/AboutPage/director1.jpeg";

const About = () => {
  

  return (
    <div className="font-lato">
      <Navbar />
      <div className="flex flex-col md:flex-row gap-4 md:gap-8 max-w-[1200px] mx-auto my-6 md:my-8 px-4">
        <img
          src={images.AboutBanner}
          alt="about-banner"
          className="w-full md:w-[400px] lg:w-[516px] h-[280px] sm:h[350px] md:h-[400px] lg:h-[474px] rounded-[15px] md:rounded-[20px] object-cover hover:shadow-2xl hover:scale-[1.02] border border-transparent hover:border-[#1975FF]/30 transition-all duration-500"
        />
        <div>
          <h1 className="text-[28px] sm:text-[32px] md:text-[38px] lg:text-[42px] leading-tight font-bold mb-2">
            About Dev Rishi
          </h1>
          <h3 className="text-[20px] sm:text-[24px] md:text-[28px] lg:text-[32px] font-medium mb-3">
            Hospital & Research Centre
          </h3>
          <p className="text-[14px] sm:text-[16px] md:text-[17px] lg:text-[18px] font-openSans ">
            Dev Rishi Hospital is dedicated to providing world-class healthcare
            services with compassion, innovation, and excellence. Since our
            establishment, we have focused on delivering patient-first care
            backed by advanced medical technology. Our hospital is equipped with
            modern infrastructure, highly trained medical professionals, and a
            commitment to continuous improvement. We understand that healthcare
            is not just about treating illnesses it's about caring for people
            and improving lives. We combine medical expertise with personalized
            care to ensure each patient receives the best possible treatment.
            Our multidisciplinary approach brings together specialists from
            various fields to provide comprehensive healthcare solutions.
          </p>
          <Link
            to="/vision-mission"
            className="w-fit mt-8 bg-[#1975FF] rounded-[10px] py-1 pr-1 pl-4 flex items-center gap-2 text-[14px] font-semibold text-white hover:bg-[#1560d4] active:bg-[#1050b8] active:scale-95 transition-all duration-200 shadow-md hover:shadow-lg group"
          >
            Learn more about Vision and Mission{" "}
            <span className="p-2 bg-white rounded-full transition-transform duration-300 group-hover:scale-110">
              <MoveRight color="#000" className="rotate-[-38deg] w-5 h-5" />
            </span>
          </Link>
        </div>
      </div>
      {/* Founders Message */}
      <h2 className="text-[22px] sm:text-[26px] md:text-[28px] text-[#1F2933] font-bold mt-8 md:mt-10 mb-4 md:mb-6 text-center px-4">
        Founder's Message
      </h2>
      <div className="group max-w-[952px] mx-auto flex flex-col sm:flex-row gap-3 sm:gap-4 md:gap-6 items-start px-4 sm:px-6 pt-6 sm:pt-8 pb-4 shadow-[0px_0px_25px_0px_#CECDDA33] hover:shadow-[0px_10px_40px_0px_#CECDDA66] rounded-[20px] md:rounded-[35px] bg-white border border-transparent hover:border-[#1975FF]/20 hover:bg-[#F8FAFF] hover:-translate-y-2 transition-all duration-500 my-4 mx-4">
        <img
          src={images.FounderImg}
          alt="founderImage"
          className="w-full sm:w-[180px] md:w-[224px] h-[250px] sm:h-[250px] md:h-[272px] object-cover rounded-[10px] group-hover:scale-[1.02] group-hover:shadow-md transition-all duration-500"
        />
        <div className="w-full">
          <div className="flex flex-col md:flex-row md:justify-between items-start gap-3 md:gap-4">
            <div>
              <p className="text-[#1F2933] text-[16px] sm:text-[18px] md:text-[20px] font-bold">
                Ch. Hari Pal Singh
              </p>
              <p className="text-[#1F2933] text-[14px] sm:text-[16px] md:text-[18px] mt-1">
                Founder, Hari Group of Institutions
              </p>
            </div>
            <div>
              <p className="text-[#4B1D1D] text-[12px] sm:text-[13px] md:text-[14px] font-poppins font-medium mb-5 max-w-[266px]">
                “न हि देहभृता शक्यं त्यक्तुं कर्माण्यशेषतः | यस्तु कर्मफलत्यागी
                स त्यागीत्यभिधीयते ||”
              </p>
              <p className="font-openSans font-semibold text-[12px] sm:text-[13px] md:text-[14px] italic">
                "It is not possible for the embodied being to renounce all
                action,but one who renounces the fruits of action is said to
                have truly renounced."
              </p>
            </div>
          </div>
          <p className="font-openSans text-[13px] sm:text-[14px] md:text-base mt-4">
            Welcome to Dev Rishi Hospital. Since our inception, our vision has
            been to provide high-quality healthcare that supports the well-being
            of every patient—physically, emotionally, and holistically. At Dev
            Rishi Hospital, we are committed to creating a safe and
            compassionate environment that promotes healing, trust, and medical
            excellence. Our focus is on combining advanced technology with
            expert care to deliver the best possible outcomes for every patient.
          </p>
        </div>
      </div>
      {/* Chairman Message */}
      <h2 className="text-[22px] sm:text-[26px] md:text-[28px] text-[#1F2933] font-bold mt-8 md:mt-10 mb-4 md:mb-6 text-center px-4">
        Chairman's Message
      </h2>
      <div className="group max-w-[952px] mx-auto flex flex-col sm:flex-row gap-3 sm:gap-4 md:gap-6 items-start px-4 sm:px-6 pt-6 sm:pt-8 pb-4 shadow-[0px_0px_25px_0px_#CECDDA33] hover:shadow-[0px_10px_40px_0px_#CECDDA66] rounded-[20px] md:rounded-[35px] bg-white border border-transparent hover:border-[#1975FF]/20 hover:bg-[#F8FAFF] hover:-translate-y-2 transition-all duration-500 my-4 mx-4">
        <img
          src={images.ChairmanImg}
          alt="founderImage"
          className="w-full sm:w-[180px] md:w-[224px] h-[250px] sm:h-[250px] md:h-[272px] object-cover rounded-[10px] group-hover:scale-[1.02] group-hover:shadow-md transition-all duration-500"
        />
        <div className="w-full">
          <div className="flex flex-col md:flex-row md:justify-between items-start gap-3 md:gap-4">
            <div>
              <p className="text-[#1F2933] text-[16px] sm:text-[18px] md:text-[20px] font-bold">
                Dr. Subhash Choudhary
              </p>
              <p className="text-[#1F2933] text-[14px] sm:text-[16px] md:text-[18px] mt-1">
                Chairman, Hari Group of Institutions
              </p>
            </div>
            <div>
              <p className="text-[#4B1D1D] text-[12px] sm:text-[13px] md:text-[14px] font-poppins font-medium mb-5 max-w-[266px]">
                “उद्धरेदात्मनात्मानं नात्मानमवसादयेत् | आत्मैव ह्यात्मनो
                बन्धुरात्मैव रिपुरात्मनः ||”
              </p>
              <p className="font-openSans font-semibold text-[12px] sm:text-[13px] md:text-[14px] italic">
                "One should lift oneself by one's own efforts and should not
                degrade oneself.The self is the friend of the self, and the self
                is the enemy of the self."
              </p>
            </div>
          </div>
          <p className="font-openSans text-[13px] sm:text-[14px] md:text-base mt-4">
            As the Chairman of Dev Rishi Hospital, I am immensely proud of the
            journey we have undertaken in delivering quality healthcare services
            to our community. Our vision of making advanced and affordable
            healthcare accessible to all has helped shape Dev Rishi Hospital
            into a trusted name in medical care. We remain committed to creating
            an environment where patient well-being, medical excellence, and
            compassionate care are at the heart of everything we do.
          </p>
        </div>
      </div>
      {/* Director Message */}
      <h2 className="text-[22px] sm:text-[26px] md:text-[28px] text-[#1F2933] font-bold mt-8 md:mt-10 mb-4 md:mb-6 text-center px-4">
        Director's Message
      </h2>
      <div className="group max-w-[952px] mx-auto flex flex-col sm:flex-row gap-3 sm:gap-4 md:gap-6 items-start px-4 sm:px-6 pt-6 sm:pt-8 pb-4 shadow-[0px_0px_25px_0px_#CECDDA33] hover:shadow-[0px_10px_40px_0px_#CECDDA66] rounded-[20px] md:rounded-[35px] bg-white border border-transparent hover:border-[#1975FF]/20 hover:bg-[#F8FAFF] hover:-translate-y-2 transition-all duration-500 my-4 mx-4">
        <img
          src={director}
          alt="founderImage"
          className="w-full sm:w-[180px] md:w-[224px] h-[250px] sm:h-[250px] md:h-[272px] object-cover rounded-[10px] group-hover:scale-[1.02] group-hover:shadow-md transition-all duration-500"
        />
        <div className="w-full">
          <div className="flex flex-col md:flex-row md:justify-between items-start gap-3 md:gap-4">
            <div>
              <p className="text-[#1F2933] text-[16px] sm:text-[18px] md:text-[20px] font-bold">
                Mayank Choudhary
              </p>
              <p className="text-[#1F2933] text-[14px] sm:text-[16px] md:text-[18px] mt-1">
                Director, Hari Group of Institutions
              </p>
            </div>
            <div>
              <p className="text-[#4B1D1D] text-[12px] sm:text-[13px] md:text-[14px] font-poppins font-medium mb-5 max-w-[266px]">
                "विद्या ददाति विनयं विनयाद्याती पात्रताम् | पात्रत्वात् धनं
                प्राप्तं धनात् धर्मं ततः सुखम् ||"
              </p>
              <p className="font-openSans font-semibold text-[12px] sm:text-[13px] md:text-[14px] italic">
                "Education gives humility, humility leads to capability, from
                capability comes wealth, and wealth leads to righteousness,
                which brings happiness."
              </p>
            </div>
          </div>
          <p className="font-openSans text-[13px] sm:text-[14px] md:text-base mt-4">
            At Dev Rishi Hospital, we are committed to delivering a healthcare
            experience that integrates advanced medical expertise, modern
            technology, and compassionate patient care. Our focus is to create
            an environment where patients receive not only accurate diagnosis
            and effective treatment but also personalized attention and
            emotional support. We strive to uphold values such as trust,
            responsibility, and excellence in every aspect of care, ensuring the
            well-being and comfort of every patient we serve.
          </p>
        </div>
      </div>
      {/*  Book Appointment  */}
      <div className="py-8 sm:py-10 md:py-12 bg-[#F7F7F7B2] border border-transparent  px-4 my-6 md:my-12  hover:bg-[#F0EBFFB2] transition-all duration-500">
        <h1 className="max-w-[550px] text-center text-[20px] sm:text-[26px] md:text-[32px] font-semibold mx-auto leading-[1.2]">
          Experience Trusted Healthcare
        </h1>
        <p className="max-w-[600px] font-openSans text-[14px] sm:text-[16px] md:text-[18px] mx-auto text-center mt-2 md:mt-3">
          At Dev Rishi Hospital, we build trust through every interaction by
          providing honest guidance, accurate diagnosis, and dedicated care that
          puts your health and well-being first.
        </p>
        <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4 justify-center mt-6 md:mt-8">
          <Link
            to="/appointment"
            className="bg-[#1975FF] rounded-[10px] py-2 px-4 flex items-center justify-center sm:justify-start gap-2 text-[13px] sm:text-[14px] font-semibold text-white hover:bg-[#1560d4] active:bg-[#1050b8] active:scale-95 transition-all duration-200 shadow-md hover:shadow-lg group w-full sm:w-fit"
          >
            Book Appointment{" "}
            <span className="p-2 bg-white rounded-full transition-transform duration-300 group-hover:scale-110">
              <MoveRight color="#000" className="rotate-[-38deg] w-4 h-4" />
            </span>
          </Link>
          <a
            href="tel:+917300906444"
            className="border border-black rounded-[10px] py-2 px-4 flex items-center justify-center sm:justify-start gap-2 text-[13px] sm:text-[14px] font-semibold text-black hover:bg-black hover:text-white active:bg-[#1a1a1a] active:scale-95 transition-all duration-200 w-full sm:w-fit"
          >
            <span className="p-2 bg-[#F59E0B] rounded-full">
              <Phone color="#ffffff" className="w-4 h-4" />
            </span>
            Call Now
          </a>
        </div>
      </div>
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default About;
